import React from 'react';
import cx from 'classnames';

import { ArrowRightIcon, IconComponentProps } from '@motorway/mw-highway-code';
import { Hyperlink, HyperlinkProps } from '@motorway/mw-highway-code/alpha';
import { IconTextWithSubtext, IconTextWithSubtextProps } from '@motorway/mw-highway-code/src/components/__primitives__/IconTextWithSubtext';

import styles from './IconTextActionCard.module.scss';

export type IconTextActionCardProps = Prettify<
Pick<IconTextWithSubtextProps, 'icon' | 'subtext' | 'text'>
& Omit<HyperlinkProps<'button'>, 'label' | 'as' | 'children' | 'inherit'>& {
  href?: string; // Allow href to be passed
}>

export const IconTextActionCard = (props: IconTextActionCardProps) => {
  const { href, icon: Icon, subtext, text, ...hyperlinkProps } = props;

  return (
    <div className={cx(styles.iconTextActionCard)} data-testid="icon-text-action-card">
      <Hyperlink
        {...hyperlinkProps}
        data-thc-hyperlink
        inherit
        as="button"
        label={(
          <div className={cx(styles.contentWrapper)}>
            <IconTextWithSubtext
              data-thc-icontext
              icon={(p: IconComponentProps) => (
                <div className={cx(styles.iconWrapper)}>
                  {Icon && <Icon {...p} /> }
                </div>
              )}
              subtext={
                <span className={cx(styles.subtext)}>
                  {subtext}
                </span>
              }
              text={text}
              variant='xsmall--heading6'
            />
            <div className={cx(styles.arrowIcon)}><ArrowRightIcon size="xsmall" /></div>
          </div>
        )}
      />
    </div>
  );
};
